import React, { useState, useEffect, useRef } from 'react';
import './Card.css';
import Rating from './Rating';
import axios from 'axios';

export default function Card({
  title,
  image,
  price,
  colors,
  carousel,
  availableQuantity,
  description,
  size,
  id,
  idr,
  reviews
}) {
  const [selectedColor, setSelectedColor] = useState(colors?.[0]?.said || '');
  const [selectedSize, setSelectedSize] = useState(size?.[0] || '');
  const [showall, setShowall] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [imgIndex, setImgIndex] = useState(0);
  const [value, setValue] = useState(0); // rating value
  const [mobile, setMobile] = useState(false);
  const [productReviews, setProductReviews] = useState(reviews || []);
  const [currentReviewPage, setCurrentReviewPage] = useState(1);
  
  const timedivRef = useRef(null);
  const carouselRef = useRef(null); // <-- ref for carousel

  // Review pagination settings
  const reviewsPerPage = 3;
  const totalReviewPages = Math.ceil(productReviews.length / reviewsPerPage);
  const indexOfLastReview = currentReviewPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentPageReviews = productReviews.slice(indexOfFirstReview, indexOfLastReview);

  // Update reviews when prop changes
  useEffect(() => {
    if (reviews && Array.isArray(reviews)) {
      setProductReviews(reviews);
      setCurrentReviewPage(1); // Reset page when reviews change
    }
  }, [reviews]);
  // Handle star click
  const handleClick = (i) => {
    const newValue = i + 1;
    setValue(newValue);

    let productData = JSON.parse(localStorage.getItem('productData')) || {};
    productData[title] = {
      ...(productData[title] || {}),
      selectedStars: newValue
    };
    localStorage.setItem('productData', JSON.stringify(productData));
  };

  // Submit review
  const submitReview = async () => {
    // Check if user is logged in
    const userEmail = localStorage.getItem('userEmail');
    const userName = localStorage.getItem('userName');

    if (!userEmail || !userName) {
      alert('Please log in to submit a review.');
      return;
    }

    const reviewText = document.getElementById('review').value.trim();
    if (!reviewText || value === 0) {
      alert('Please provide both a rating and review text.');
      return;
    }

    try {
      // Prepare review data for API
      const reviewData = {
        username: userName,
        email: userEmail,
        productId: id,
        productTitle: title,
        rating: value,
        review: reviewText
      };

      console.log('Sending review data:', reviewData);

      // Send review to API
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/Reviews`, reviewData);

      console.log('API Response:', response);

      if (response.data.success || response.status === 200) {
        // Get current products from localStorage
        const products = JSON.parse(localStorage.getItem('Products')) || [];
        const productIndex = products.findIndex(p => p.idn === id || p.title === title);

        if (productIndex !== -1) {
          // Use the review data returned from API
          const newReview = response.data.review || {
            username: userName,
            rating: value,
            review: reviewText,
            createdAt: new Date().toISOString()
          };

          // Add review to product
          if (!products[productIndex].reviews) {
            products[productIndex].reviews = [];
          }
          products[productIndex].reviews.push(newReview);

          // Update localStorage
          localStorage.setItem('Products', JSON.stringify(products));

          // Update local state to display new review immediately
          setProductReviews([...productReviews, newReview]);
          
          console.log('Review added to product:', productIndex);
        }

        // Clear the form
        document.getElementById('review').value = '';
        setValue(0);

        alert('Review submitted successfully!');
      } else {
        console.error('Unexpected response:', response);
        alert('Failed to submit review. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText
      });
      alert('Error submitting review. Please check your connection and try again.');
    }
  };

  // Add to cart
  const AddToCart = () => {
    let Added = JSON.parse(localStorage.getItem('Added')) || [];
    let PCart = {
      title: title,
      color: selectedColor,
      size: selectedSize,
      img: (carousel && carousel[imgIndex]) || image,
      price,
      quantity,
      id: idr
    };
    Added.push(PCart);
    localStorage.setItem('Added', JSON.stringify(Added));
    console.log("Cart updated:", Added);
    fadenotify();
  };

  const fadenotify = () => {
    const timediv = timedivRef.current;
    if (!timediv) return;

    timediv.style.position = 'fixed';
    timediv.style.display = 'block';
    setTimeout(() => {
      timediv.style.top = '300px';
      setTimeout(() => {
        timediv.style.top = '-40px';
        setTimeout(() => {
          timediv.style.display = 'none';
        }, 500);
      }, 2000);
    }, 500);
  };

  // Responsive card size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 783) {
        setMobile(false);
      } else {
        setMobile(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleShopCardClick = () => setShowall(!showall);

  return (
    <div
      className="card"
      style={{
        position: showall ? "fixed" : "relative",
        top: showall ? "50%" : "auto",
        left: showall ? "50%" : "auto",
        margin: showall ? "0 auto" : "20px",
        transform: showall ? "translate(-50%, -50%)" : "none",
        zIndex: showall ? 9000 : 1,
        background: showall ? '#1a1a16' : "transparent",
        width: showall ? '100%' : mobile ? '60%' : '15%',
        height: showall ? '100%' : 'auto',
      }}
    >
      <div className="timediv" ref={timedivRef}>
        <h3>Added to Your Cart <i className="fa-solid fa-check"></i></h3>
      </div>

      {/* Close Button */}
      <button
        onClick={() => setShowall(false)}
        id='crossbtn'
        style={{ display: showall ? 'flex' : 'none' }}
      >
        <i className='fa-solid fa-xmark'></i>
      </button>

      {/* Main Image */}
      <img src={image} alt={title} id='mainimg' loading='auto' style={{ display: showall || mobile ? 'none' : 'block' }} />

      {/* Carousel */}
      <div className="carousel" ref={carouselRef} style={{ display: showall ? 'flex' : 'none' }}>
        {(carousel || []).map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${title} ${index + 1}`}
            style={{ flex: '0 0 auto' }}
          />
        ))}
      </div>

      {/* Mobile Card */}
      <div className="mobilediv" style={{ display: !showall ? mobile ? 'flex' : 'none' : 'none' }}>
        <img src={image} alt={title} style={{ display: showall ? 'none' : 'block' }} />
        <div className="ok">
          <h2 onClick={e => e.stopPropagation()}>{title}</h2>
          <p onClick={e => e.stopPropagation()}>Rs. {price}</p>
          <button
            onClick={handleShopCardClick}
            style={{ display: showall ? 'none' : 'block', width: '100%', padding: '20px', fontSize: '18px', margin: '10px auto' }}
          >
            Shop Now
          </button>
        </div>
      </div>

      {/* Title & Price */}
      <h2 style={{ display: showall ? 'block' : mobile ? 'none' : 'block' }} onClick={e => e.stopPropagation()}>{title}</h2>
      <p style={{ display: showall ? 'block' : mobile ? 'none' : 'block' }} onClick={e => e.stopPropagation()}>Rs. {price}</p>
      <p style={{ display: showall ? 'block' : 'none', color: '#c2b280' }} onClick={e => e.stopPropagation()}>
        <span id='heading'>Description:</span><br /> {description}
      </p>

      {/* Color Options */}
      <div className="color-options" style={{ display: showall ? 'flex' : 'none' }}>
        {(colors || []).map((color, index) => (
          <button
            key={color.said}
            type="button"
            aria-label={`Select ${color.said}`}
            style={{
              backgroundColor: color.hex,
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              border: selectedColor === color.said ? '2px solid #c2b280' : '2px solid #fff',
              display: 'inline-block',
              cursor: 'pointer',
              padding: 0,
              margin: 0,
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedColor(color.said);
              setImgIndex(index);

              const carouselEl = carouselRef.current;
              if (carouselEl) {
                const imgWidth = carouselEl.querySelector('img')?.offsetWidth || 0;
                carouselEl.scrollTo({
                  left: imgWidth * index,
                  behavior: 'smooth'
                });
              }
            }}
          />
        ))}
      </div>

      {/* Size Options */}
      <div className="size-options" style={{ display: showall ? 'flex' : 'none' }}>
        {(size || []).map((s) => (
          <span
            key={s}
            style={{
              backgroundColor: '#c2b280',
              boxShadow: selectedSize === s ? `0 0 10px 2px #c2b280` : 'none',
            }}
            onClick={(e) => { e.stopPropagation(); setSelectedSize(s); }}
          >
            {s}
          </span>
        ))}
      </div>

      {/* Rating */}
      <div className='rating' style={{ display: showall ? 'block' : 'none', gap: '2px', color: '#FFD700', cursor: 'pointer' }}>
        <h2>Rate & Review</h2>
        {localStorage.getItem('userEmail') ? (
          <Rating value={value} onChange={(data) => {
            setValue(data.selectedStars);
            handleClick(data.selectedStars - 1); // Adjust for 0-based index
          }} />
        ) : (
          <p style={{ color: '#a19368', fontSize: '14px', fontFamily: '"Ubuntu", sans-serif' }}>
            Please log in to rate and review this product.
          </p>
        )}
      </div>

      <div className="textreview" style={{ display: showall ? 'block' : 'none' }}>
        {localStorage.getItem('userEmail') ? (
          <>
            <textarea name="Review" id="review" cols="35" rows="8" placeholder='Write the feedback.'></textarea>
            <button type="button" onClick={submitReview}>Submit Review</button>
          </>
        ) : (
          <p style={{ color: '#a19368', fontSize: '14px', fontFamily: '"Ubuntu", sans-serif', textAlign: 'center' }}>
            Please log in to submit a review.
          </p>
        )}
      </div>

      {/* Product Reviews Display */}
      {productReviews && productReviews.length > 0 && (
        <div className="product-reviews" style={{ display: showall ? 'block' : 'none', marginTop: '20px' }}>
          <h3 style={{ color: '#c2b280', fontSize: '20px', borderBottom: '2px solid #c2b280', paddingBottom: '10px', marginBottom: '15px' }}>
            Customer Reviews ({productReviews.length})
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', maxHeight: '400px', overflowY: 'auto' }}>
            {currentPageReviews.map((review, index) => (
              <div
                key={review.id || index}
                style={{
                  border: '1px solid #c2b280',
                  borderRadius: '8px',
                  padding: '12px',
                  backgroundColor: 'rgba(194, 178, 128, 0.05)'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <h4 style={{ color: '#c2b280', margin: '0', fontSize: '16px' }}>
                    {review.username}
                  </h4>
                  <span style={{ color: '#a19368', fontSize: '12px' }}>
                    {review.createdAt ? new Date(review.createdAt).toLocaleDateString() : review.date}
                  </span>
                </div>
                
                {/* Rating Stars */}
                <div style={{ marginBottom: '8px', color: '#FFD700' }}>
                  {Array(5).fill().map((_, i) => (
                    <span key={i} style={{ fontSize: '16px', marginRight: '2px' }}>
                      {i < review.rating ? '★' : '☆'}
                    </span>
                  ))}
                </div>

                {/* Review Text */}
                <p style={{ color: '#c2b280', margin: '0', fontSize: '14px', lineHeight: '1.5' }}>
                  {review.review}
                </p>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          {totalReviewPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '15px', flexWrap: 'wrap' }}>
              {/* Previous Button */}
              <button
                onClick={() => setCurrentReviewPage(p => Math.max(1, p - 1))}
                disabled={currentReviewPage === 1}
                style={{
                  width: 'max-content',
                  padding: '8px 12px',
                  border: '1px solid #c2b280',
                  background: currentReviewPage === 1 ? '#555' : 'transparent',
                  color: currentReviewPage === 1 ? '#999' : '#c2b280',
                  borderRadius: '4px',
                  cursor: currentReviewPage === 1 ? 'not-allowed' : 'pointer',
                  fontSize: '12px',
                  fontFamily: '"Ubuntu", sans-serif'
                }}
              >
                Previous
              </button>

              {/* Page Numbers */}
              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                {(() => {
                  const pages = [];
                  const maxVisiblePages = 3;

                  if (totalReviewPages <= maxVisiblePages) {
                    // Show all pages if total is 3 or less
                    for (let i = 1; i <= totalReviewPages; i++) {
                      pages.push(i);
                    }
                  } else {
                    // Show first page
                    pages.push(1);

                    // Add ellipsis or pages in middle
                    if (currentReviewPage > 2) {
                      pages.push('...');
                    }

                    // Add current page and adjacent pages
                    if (currentReviewPage > 1 && currentReviewPage < totalReviewPages) {
                      pages.push(currentReviewPage);
                    }

                    // Add ellipsis before last page
                    if (currentReviewPage < totalReviewPages - 1) {
                      pages.push('...');
                    }

                    // Add last page
                    pages.push(totalReviewPages);
                  }

                  return pages.map((page, idx) => (
                    page === '...' ? (
                      <span key={idx} style={{ color: '#a19368', padding: '0 4px' }}>
                        ...
                      </span>
                    ) : (
                      <button
                        key={idx}
                        onClick={() => setCurrentReviewPage(page)}
                        style={{
                          width: '32px',
                          height: '32px',
                          padding: '0',
                          border: currentReviewPage === page ? '2px solid #c2b280' : '1px solid #c2b280',
                          background: currentReviewPage === page ? '#c2b280' : 'transparent',
                          color: currentReviewPage === page ? '#000' : '#c2b280',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          fontFamily: '"Ubuntu", sans-serif',
                          fontWeight: currentReviewPage === page ? 'bold' : 'normal'
                        }}
                      >
                        {page}
                      </button>
                    )
                  ));
                })()}
              </div>

              {/* Next Button */}
              <button
                onClick={() => setCurrentReviewPage(p => Math.min(totalReviewPages, p + 1))}
                disabled={currentReviewPage === totalReviewPages}
                style={{
                  width: 'max-content',
                  padding: '8px 12px',
                  border: '1px solid #c2b280',
                  background: currentReviewPage === totalReviewPages ? '#555' : 'transparent',
                  color: currentReviewPage === totalReviewPages ? '#999' : '#c2b280',
                  borderRadius: '4px',
                  cursor: currentReviewPage === totalReviewPages ? 'not-allowed' : 'pointer',
                  fontSize: '12px',
                  fontFamily: '"Ubuntu", sans-serif'
                }}
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}

      {/* Sticky Cart Controls */}
      <div className="btnsticky" style={{ display: showall ? 'flex' : 'none' }}>
        <div className="quantity" style={{ display: showall ? 'flex' : 'none' }}>
          <button onClick={e => { e.stopPropagation(); setQuantity(q => Math.max(1, q - 1)); }}>-</button>
          <h3>{quantity}</h3>
          <button onClick={e => { e.stopPropagation(); setQuantity(q => q + 1); }}>+</button>
        </div>
        <button
          type="button"
          className='addcart'
          style={{ display: showall ? 'block' : 'none' }}
          onClick={AddToCart}
        >
          Add to Cart
        </button>
      </div>

      {/* Shop Now Button */}
      <button
        onClick={handleShopCardClick}
        style={{
          display: showall || mobile ? 'none' : 'block', width: '55%', margin: '10px auto'
        }}
      >
        Shop Now
      </button>
    </div>
  );
}
